import jsSIP from 'jssip'
import { setCredentials, configuration } from '../configuration'
import { setPhoneSession, setAudio, getCall } from './sessionHandler'
import { setCallAndRedirect } from './incomingCall'
import { setLastPing } from './networkDisconnectionHandler'

export default (username, password) => {
  jsSIP.debug.enable('jsSIP:*')

  setCredentials(username, password)

  const config = configuration
  const phone = new jsSIP.UA(config)

  phone
    .on('connected', e => {
      console.log('connected')
    })
    .on('registered', e => {
      console.log('registered')
    })
    .on('registrationFailed', e => {
      console.log('registrationFailed')
    })
    .on('unregistered', e => {
      console.log('unregistered')
    })
    .on('newOptions', e => {
      setLastPing()
    })
    .on('newRTCSession', e => {
      if (getCall() != undefined) return
      if (e.session.direction === 'incoming') setCallAndRedirect(e)
    })

  phone.start()

  setPhoneSession(phone)
  setAudio()
}
